import React from "react";
import { useAuth } from "utilities/auth";
import { isInternal } from "utilities/userType";
import RerunnerList from "./RerunnerList";
import RerunnerDetail from "./RerunnerDetail";

export default function RerunnerPage() {
  const { user } = useAuth();

  if (isInternal(user)) return <RerunnerList />;
  return <RerunnerDetail />;
}
